export const INFO = {
  name: "Bar Incontro",
  city: "Pesaro",
  address: "Via Palmiro Togliatti 19, 61122 Pesaro PU",
  phoneDisplay: "0721 396600",
  phoneHref: "tel:+390721396600",
  plusCode: "VVXR+22 Pesaro",
  rating: "4,3",
  reviewCount: 244,
  priceRange: "1–10 € a persona",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Via+Palmiro+Togliatti+19,+61122+Pesaro+PU",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=Via+Palmiro+Togliatti+19,+61122+Pesaro+PU",
  mapsEmbed:
    "https://maps.google.com/maps?q=Via%20Palmiro%20Togliatti%2019%2C%2061122%20Pesaro%20PU&z=16&output=embed",
};

export const HERO_IMAGE = "/photos/banco.jpg";

export const STORIA_IMAGES = {
  interior: "/photos/interno.jpg",
  breakfast: "/photos/dehors1.jpg",
};

export const MARQUEE_ITEMS = [
  "Colazioni artigianali",
  "Caffè espresso",
  "Brioche fresche",
  "Aperitivi & Spritz",
  "Ampi spazi interni ed esterni",
  "Via Togliatti 19 · Pesaro",
];

export const MENU = {
  colazione: [
    {
      name: "Espresso al banco",
      desc: "Tostatura intensa, servito come si deve: al banco, come tradizione.",
      icon: "coffee",
    },
    {
      name: "Cappuccino",
      desc: "Schiuma montata al momento, cacao e zabaione a piacere.",
      icon: "coffee",
    },
    {
      name: "Brioche alla crema",
      desc: "Soffice e profumata.",
      icon: "croissant",
      badge: "La più amata",
    },
    {
      name: "Cornetti & brioche integrali",
      desc: "La selezione quotidiana, dolce e sfogliata.",
      icon: "croissant",
    },
    {
      name: "Torte e dolci della casa",
      desc: "Vetrina sempre fornita: la pausa dolce perfetta.",
      icon: "cake",
    },
    {
      name: "Spremute e succhi",
      desc: "Frutta fresca del giorno.",
      icon: "citrus",
    },
  ],
  aperitivi: [
    {
      name: "Aperol Spritz",
      desc: "Il preferito dei clienti, servito bene ghiacciato.",
      icon: "martini",
      badge: "Il più richiesto",
    },
    {
      name: "Cocktail & classici",
      desc: "La carta dei grandi classici, dal Negroni all'Americano.",
      icon: "glass",
    },
    {
      name: "Calici di vino",
      desc: "Una selezione di vini per accompagnare l'ora giusta.",
      icon: "wine",
    },
    {
      name: "Taglieri il venerdì",
      desc: "Per condividere, dentro o fuori.",
      icon: "utensils",
    },
    {
      name: "Stuzzichini & olive",
      desc: "Il gusto in più che accompagna l'aperitivo.",
      icon: "popcorn",
    },
  ],
};

export const REVIEW_TAGS = [
  { id: "aperitivi", count: 15 },
  { id: "colazione", count: 11 },
  { id: "dolci", count: 5 },
  { id: "cordiale", count: 5 },
  { id: "ambiente", count: 3 },
  { id: "brioche", count: 2 },
];

export const REVIEWS = [
  {
    name: "Graziella Lippolis",
    meta: "Local Guide · 28 recensioni",
    when: "5 mesi fa",
    text: "Ottimo locale, nonché servizio e cortesia dei gestori",
    tags: ["cordiale"],
    highlight: false,
  },
  {
    name: "amelia maltoni",
    meta: "1 recensione",
    when: "un anno fa",
    text: "Personale molto educato, gentile e disponibile, cibo ottimo e ambiente accogliente! Sicuramente conto di tornare",
    tags: ["cordiale", "ambiente"],
    highlight: false,
  },
  {
    name: "Omar Broccoli",
    meta: "3 recensioni",
    when: "un anno fa",
    text: "Ottimo locale, rinnovato e con ampi spazi interni ed esterni.",
    extra: "Cibo: 5",
    tags: ["ambiente"],
    highlight: false,
  },
  {
    name: "Recensione in evidenza",
    meta: "Google",
    when: "",
    text: "Prodotti molto buoni e varietà di dolci e salati.",
    tags: ["dolci"],
    highlight: true,
  },
  {
    name: "Recensione in evidenza",
    meta: "Google",
    when: "",
    text: "Ottima scelta, pulizia, gentilezza, posti a sedere dentro e fuori, parcheggio.",
    tags: ["ambiente", "cordiale"],
    highlight: true,
  },
  {
    name: "Recensione in evidenza",
    meta: "Google",
    when: "",
    text: "Personale gentilissimo e ottime colazioni",
    tags: ["colazione"],
    highlight: true,
  },
];

export const GALLERY = [
  {
    src: "/photos/banco.jpg",
    cat: "spazi",
    caption: "Il banco con le piastrelle rosse",
  },
  {
    src: "/photos/interno.jpg",
    cat: "spazi",
    caption: "La sala e il banco",
  },
  {
    src: "/photos/salone.jpg",
    cat: "spazi",
    caption: "L'angolo con la libreria",
  },
  {
    src: "/photos/divanetto.jpg",
    cat: "spazi",
    caption: "Il divano rosso davanti alla TV",
  },
  {
    src: "/photos/esterno.jpg",
    cat: "spazi",
    caption: "L'ingresso su Via Togliatti",
  },
  {
    src: "/photos/dehors1.jpg",
    cat: "spazi",
    caption: "Il dehors con l'ombrellone",
  },
  {
    src: "/photos/dehors2.jpg",
    cat: "spazi",
    caption: "I divanetti all'aperto",
  },
  {
    src: "/photos/cornetti.jpg",
    cat: "colazioni",
    caption: "Cornetti freschi ogni mattina",
  },
  {
    src: "/photos/brioche.jpg",
    cat: "colazioni",
    caption: "Brioche e bomboloni della vetrina",
  },
  {
    src: "/photos/cappuccino.jpg",
    cat: "colazioni",
    caption: "Cappuccino e girella alla crema.",
  },
  {
    src: "/photos/caffe-panna.jpg",
    cat: "colazioni",
    caption: "Caffè di ogni tipo.",
  },
  {
    src: "/photos/biscotti.jpg",
    cat: "colazioni",
    caption: "I biscotti della vetrina",
  },
  {
    src: "/photos/pizzette.jpg",
    cat: "salati",
    caption: "La rossini di Pesaro",
  },
  {
    src: "/photos/panini.jpg",
    cat: "salati",
    caption: "Panini e farciti freschi",
  },
  {
    src: "/photos/tramezzini.jpg",
    cat: "salati",
    caption: "Tramezzini del giorno",
  },
];
